import { format as dateFnsFormat } from 'date-fns/format';

export type DateTimeFormat = 'date' | 'datetime' | 'time' | string;

function toDateFnsFormat(format: DateTimeFormat) {
  switch (format) {
    case 'date':
      return 'dd.MM.yyyy';
    case 'time':
      return 'HH:mm';
    case 'datetime':
      return 'dd.MM.yyyy HH:mm';
    default:
      return format;
  }
}

export function formatDate(
  value: string | number | Date | undefined | null,
  format: DateTimeFormat = 'datetime',
) {
  if (!value) {
    return undefined;
  }

  return dateFnsFormat(value, toDateFnsFormat(format));
}

export function formatCardExpirationDate(value: string | number | Date | undefined | null) {
  if (!value) {
    return undefined;
  }

  return dateFnsFormat(value, 'MM/yy');
}
